import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  updateAnnualTransactions,
  updateMonthTransactions,
  updateTransactionDetails,
  updateTransactionDetailsDestination,
  updateTransactionDetailsOrigin,
} from '../../features/transactions/transactionSlice'
import { convertToUTCDate, formatDate } from '../../components/common/time/timeHelper'
import { getClientKeyWithAccessToken } from '../../lib/security'

export const useTransactionDetails = (tId, setIsLoading, isLoading) => {
  const { accessToken, emailClient } = useSelector((state) => state.login)
  const { transactionDetails } = useSelector((state) => state.transaction)
  const dispatch = useDispatch()

  useEffect(() => {
    if (tId !== transactionDetails?.transactionId || isLoading) {
      const baseUrlTransactions = `${process.env.REACT_APP_BASEURL}/kyt/retrieveTransaction/${tId}`

      getClientKeyWithAccessToken(accessToken)
        .then((clientKey) => {
        
          const options = {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${accessToken}`,
              'client-key': clientKey,
            },
          }

          return fetch(process.env.REACT_APP_IS_DEMO ? '../data/transaction.details.json' : baseUrlTransactions, options)
            .then((res) => res.json())
            .then((res) => {
              if (res.data) {
                dispatch(updateTransactionDetails(res.data))
                dispatch(updateTransactionDetailsOrigin({}))
                dispatch(updateTransactionDetailsDestination({}))
                if (res.data && res.data.originUserId) {
                  const url = `${process.env.REACT_APP_BASEURL}/kyt/users/${res.data.originUserId}/${emailClient}`
                  fetch(process.env.REACT_APP_IS_DEMO ? '../data/kyt.both.json' : url, options)
                    .then((resOr) => resOr.json())
                    .then((resOr) => {
                      if (resOr.data) {
                        resOr.data = process.env.REACT_APP_IS_DEMO
                          ? resOr.data?.filter((element) => {
                              return element.userId === res.data.originUserId
                            })[0]
                          : resOr.data
                        dispatch(updateTransactionDetailsOrigin(resOr.data))
                      } else {
                        throw new Error('User Not Found.')
                      }
                    })
                    .catch((error) => {
                      console.error('[HOOK: useTransactionDetailsOrigin] --> ', error)
                    })
                    .finally(() => setIsLoading(false))
                } else {
                  setIsLoading(false)
                }
    
                if (res.data.destinationUserId) {
                  const url = `${process.env.REACT_APP_BASEURL}/kyt/users/${res.data.destinationUserId}/${emailClient}`
                  fetch(process.env.REACT_APP_IS_DEMO ? '../data/kyt.both.json' : url, options)
                    .then((resDest) => resDest.json())
                    .then((resDest) => {
                      if (resDest.data) {
                        resDest.data = process.env.REACT_APP_IS_DEMO
                          ? resDest.data?.filter((element) => {
                              return element.userId === res.data.destinationUserId
                            })[0]
                          : resDest.data
                        dispatch(updateTransactionDetailsDestination(resDest.data))
                      } else {
                        throw new Error('User Not Found.')
                      }
                    })
                    .catch((error) => {
                      console.error('[HOOK: useTransactionDetailsdestination] --> ', error)
                    })
                    .finally(() => setIsLoading(false))
                } else {
                  setIsLoading(false)
                }
              } else {
                setIsLoading(false)
              }
            })
        })
        .catch((error) => {
          console.error('[HOOK: useTransactionDetails] --> ', error)
          setIsLoading(false)
        })
    }
  }, [isLoading])
}

export const useTransactionsMonthPercentage = (clientEmail) => {
  const [txs, setTxs] = useState([])
  const [rendered, setRendered] = useState(false)
  const [aux, setAux] = useState(false)
  const { accessToken, activeServices } = useSelector((state) => state.login)
  const transactionState = useSelector((state) => state.transaction)
  const dispatch = useDispatch()

  const validateMonth = () => {
    activeServices?.map((path) => {
      if (path.includes('getCurrentMonthTransactionsStatePercentage')) {
        setAux(true)
      }
    })
  }

  useEffect(() => {
    if (!rendered && clientEmail && txs.length === 0 && !transactionState.monthTransactions.length && aux) {
      buildTransactions()
      setRendered(true)
    }
  }, [rendered, txs, aux])

  useEffect(() => {
    validateMonth()
  }, [activeServices])

  async function buildTransactions() {
    const url = `${process.env.REACT_APP_BASEURL}/kyt/getCurrentMonthTransactionsStatePercentage/${clientEmail}`
    try {
      const options = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${accessToken}`,
          'client-key': await getClientKeyWithAccessToken(accessToken),
        },
      }
      const res = await fetch(
        process.env.REACT_APP_IS_DEMO ? '../data/getCurrentMonthTransactionsStatePercentage.json' : url,
        options,
      )

      if (res.ok) {
        const resJson = await res.json()
        let aux = resJson.data
        if (aux.length !== 0) aux = aux.sort((a, b) => (a.percentage <= b.percentage ? 1 : -1))
        setTxs(aux)
        dispatch(updateMonthTransactions(aux))
      }
    } catch (error) {
      console.error('[GET MONTH TRANSACTIONS ERROR] -> ', error)
    }
  }
  return transactionState.monthTransactions
}

export const useAnnualTransactions = (clientEmail) => {
  const [rendered, setRendered] = useState(false)
  const [aux, setAux] = useState(false)
  const { accessToken, activeServices } = useSelector((state) => state.login)
  const transactionState = useSelector((state) => state.transaction)
  const dispatch = useDispatch()

  const dataPlot = () => {
    return [
      { month: 'jan', transactions: 0, 'consumer-users': 0, 'business-users': 0 },
      { month: 'feb', transactions: 0, 'consumer-users': 0, 'business-users': 0 },
      { month: 'mar', transactions: 0, 'consumer-users': 0, 'business-users': 0 },
      { month: 'apr', transactions: 0, 'consumer-users': 0, 'business-users': 0 },
      { month: 'may', transactions: 0, 'consumer-users': 0, 'business-users': 0 },
      { month: 'jun', transactions: 0, 'consumer-users': 0, 'business-users': 0 },
      { month: 'jul', transactions: 0, 'consumer-users': 0, 'business-users': 0 },
      { month: 'aug', transactions: 0, 'consumer-users': 0, 'business-users': 0 },
      { month: 'sep', transactions: 0, 'consumer-users': 0, 'business-users': 0 },
      { month: 'oct', transactions: 0, 'consumer-users': 0, 'business-users': 0 },
      { month: 'nov', transactions: 0, 'consumer-users': 0, 'business-users': 0 },
      { month: 'dec', transactions: 0, 'consumer-users': 0, 'business-users': 0 },
    ]
  }

  const validateAnnual = () => {
    activeServices?.map((path) => {
      if (path.includes('getAnnualSummary')) {
        setAux(true)
      }
    })
  }

  function buildTransactions() {
    const url = `${process.env.REACT_APP_BASEURL}/kyt/getAnnualSummary/${clientEmail}`
    const today = new Date()
    try {
      getClientKeyWithAccessToken(accessToken)
        .then((clientKey) => {
          return fetch(url, {
            method: 'GET',
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${accessToken}`,
              'client-key': clientKey,
            },
          })
        })
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            let mapped = dataPlot()

            for (let i in mapped) {
              for (let k in res.data) {
                res.data[k].find((t) => {
                  if (t.date.split('-')[0].toString() === mapped[i]?.month.toString()) {
                    mapped[i][k] = t.numberoftransactions
                  }
                })
              }
            }

            dispatch(updateAnnualTransactions(getLastYearMonthsStructure(mapped, today)))
          }
        })
    } catch (error) {
      console.error('[GET ANNUAL SUMMARY ERROR] -> ', error)
    }
  }

  async function buildTransactionsDemo() {
    const url = `${process.env.REACT_APP_BASEURL}/kyt/getCurrentMonthTransactionsStatePercentage/${clientEmail}`
    try {
      const options = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${accessToken}`,
          'client-key': await getClientKeyWithAccessToken(accessToken),
        },
      }
      const res = await fetch(
        process.env.REACT_APP_IS_DEMO ? '../data/getCurrentMonthTransactionsStatePercentage.json' : url,
        options,
      )

      if (res.ok) {
        let mapped = dataPlot()
        const today = new Date()

        for (let i in mapped) {
          for (let k in res.data) {
            res.data[k].find((t) => {
              if (t.date.split('-')[0].toString() === mapped[i]?.month.toString()) {
                mapped[i][k] = t.numberoftransactions
              }
            })
          }
        }

        dispatch(updateAnnualTransactions(getLastYearMonthsStructure(mapped, today)))
      }
    } catch (error) {
      console.error('[GET MONTH TRANSACTIONS ERROR] -> ', error)
    }
    return transactionState.monthTransactions
  }

  const getLastYearMonthsStructure = (data2Plot, actualDate) => {
    const aux = 11 - actualDate.getMonth()
    if (aux > 0) {
      for (let i = 0; i < aux; i++) {
        data2Plot.unshift(data2Plot[11])
      }
      data2Plot.splice(12, aux)
    }
    return data2Plot
  }

  useEffect(() => {
    setRendered(true)
  }, [])

  useEffect(() => {
    if (rendered && !transactionState.annualTransactions.length && aux) {
      if (process.env.REACT_APP_IS_DEMO) buildTransactionsDemo()
      else buildTransactions()
    }
  }, [rendered, aux])

  useEffect(() => {
    validateAnnual()
  }, [activeServices])

  return transactionState.annualTransactions
}

export const TransactionExport = async (paramLimit, accessToken, clientKey, queryStateTransaction, timezone) => {
  const {
    fromDate,
    toDate,
    transactionId,
    transactionType,
    transactionState,
    originUserId,
    destinationUserId,
    originCurrency,
    destinationCurrency,
    originMethod,
    destinationMethod,
    ruleId,
    ruleInstanceId,
    maxRuleAction,
    transactionKey,
    transactionValue,
    documentNumber,
    firstName,
    lastName,
    legalName,
    shadowRuleInstanceId,
  } = queryStateTransaction

  const urlExporReportTransactions = `${process.env.REACT_APP_BASEURL}/dataExport/retrieveData/transactions`

  function buildUrl(baseUrl) {
    let url = baseUrl
    let hasQueryParams = false

    if (paramLimit !== undefined) {
      url += `?limit=${paramLimit}`
      hasQueryParams = true
    }
    if (fromDate && toDate) {
      const fromDateStr = formatDate(convertToUTCDate(fromDate, timezone))
      const toDateStr = formatDate(convertToUTCDate(toDate, timezone))
      url += `${hasQueryParams ? '&' : '?'}fromDate=${fromDateStr}&toDate=${toDateStr}`
      hasQueryParams = true
    }
    if (ruleId?.length) {
      url += `${hasQueryParams ? '&' : '?'}ruleId=${ruleId.join(',')}`
      hasQueryParams = true
    }
    if (transactionId) {
      url += `${hasQueryParams ? '&' : '?'}transactionId=${transactionId}`
      hasQueryParams = true
    }
    if (transactionType?.length) {
      url += `${hasQueryParams ? '&' : '?'}transactionType=${transactionType.join(',')}`
      hasQueryParams = true
    }
    if (transactionState?.length) {
      url += `${hasQueryParams ? '&' : '?'}transactionState=${transactionState.join(',')}`
      hasQueryParams = true
    }
    if (shadowRuleInstanceId) {
      url += `${hasQueryParams ? '&' : '?'}shadowRuleInstanceId=${shadowRuleInstanceId}`
      hasQueryParams = true
    }
    if (originUserId) {
      url += `${hasQueryParams ? '&' : '?'}originUserId=${originUserId}`
      hasQueryParams = true
    }
    if (destinationUserId) {
      url += `${hasQueryParams ? '&' : '?'}destinationUserId=${destinationUserId}`
      hasQueryParams = true
    }
    if (originCurrency?.length) {
      url += `${hasQueryParams ? '&' : '?'}originCurrency=${originCurrency
        .map((item) => {
          return item.aka
        })
        .join(',')}`
      hasQueryParams = true
    }
    if (destinationCurrency?.length) {
      url += `${hasQueryParams ? '&' : '?'}destinationCurrency=${destinationCurrency
        .map((item) => {
          return item.aka
        })
        .join(',')}`
      hasQueryParams = true
    }
    if (originMethod?.length) {
      url += `${hasQueryParams ? '&' : '?'}originMethod=${originMethod.join(',')}`
      hasQueryParams = true
    }
    if (destinationMethod?.length) {
      url += `${hasQueryParams ? '&' : '?'}destinationMethod=${destinationMethod.join(',')}`
      hasQueryParams = true
    }
    if (ruleInstanceId) {
      url += `${hasQueryParams ? '&' : '?'}ruleInstanceId=${ruleInstanceId}`
      hasQueryParams = true
    }
    if (maxRuleAction?.length) {
      url += `${hasQueryParams ? '&' : '?'}maxRuleAction=${maxRuleAction.join(',')}`
      hasQueryParams = true
    }
    if (transactionKey?.length) {
      url += `${hasQueryParams ? '&' : '?'}key=${transactionKey.join(',')}`
      hasQueryParams = true
    }
    if (transactionValue?.length) {
      url += `${hasQueryParams ? '&' : '?'}value=${transactionValue.join(',')}`
      hasQueryParams = true
    }
    if (documentNumber) {
      url += `${hasQueryParams ? '&' : '?'}documentNumber=${documentNumber}`
      hasQueryParams = true
    }
    if (firstName) {
      url += `${hasQueryParams ? '&' : '?'}firstName=${firstName}`
      hasQueryParams = true
    }
    if (lastName) {
      url += `${hasQueryParams ? '&' : '?'}lastName=${lastName}`
      hasQueryParams = true
    }
    if (legalName) {
      url += `${hasQueryParams ? '&' : '?'}legalName=${legalName}`
      hasQueryParams = true
    }
    return url
  }

  let urlGetExportrReportTransactions = buildUrl(urlExporReportTransactions)

  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'client-key': clientKey,
    },
  }

  try {
    const res = await fetch(
      process.env.REACT_APP_IS_DEMO ? './data/transactions.json' : urlGetExportrReportTransactions,
      options,
    )

    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`)
    }

    return res
  } catch (error) {
    console.error('[HOOK: transactionExport] --> ', error)
    throw error
  }
}
